import {
  Component
} from '@angular/core';


export class SkyActionButtonContainerComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-action-button-container',
  styles: [`@media (min-width: 768px) {
  .sky-action-button-container {
    display: flex;
    align-items: stretch;
  }
}

@media (max-width: 767px) {
  .sky-action-button-container {
    padding-top: 0;
  }
  .sky-action-button-container /deep/.sky-action-button {
    margin-top: 20px;
  }
}

.sky-action-button-container {
  padding-top: 20px;
}

.sky-action-button-container /deep/.sky-action-button {
  height: 100%;
  min-width: 236px;
  margin-left: 10px;
  margin-right: 10px;
}
`],
  template: `<div class="sky-action-button-container">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
